"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SelectField_exports = {};
__export(SelectField_exports, {
  SelectField: () => SelectField
});
module.exports = __toCommonJS(SelectField_exports);
var import_react = __toESM(require("react"));
var import_useErrorStyles = require("./useErrorStyles");
var import_useRegister = require("./useRegister");
const SelectField = (0, import_react.forwardRef)(
  ({
    name,
    id,
    emptyAs,
    // for useErrorStyles
    errorClassName,
    errorStyle,
    className,
    style,
    // for useRegister
    validation,
    onBlur,
    onChange,
    ...rest
  }, ref) => {
    const styles = (0, import_useErrorStyles.useErrorStyles)({
      name,
      errorClassName,
      errorStyle,
      className,
      style
    });
    const useRegisterReturn = (0, import_useRegister.useRegister)(
      {
        name,
        validation,
        onBlur,
        onChange
      },
      ref,
      emptyAs
    );
    return /* @__PURE__ */ import_react.default.createElement("select", { id: id || name, ...rest, ...styles, ...useRegisterReturn });
  }
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SelectField
});
